export default [{
    id: '',
    label: '全部'
}, {
    id: '1',
    label: '信用卡'
}, {
    id: '2',
    label: '储蓄卡'
},];



// WEBPACK FOOTER //
// ./src/service/constant/CardTypes.js